import { plugins as BaseEditorPlugins } from './EditorPlugins'
import makeLinkPlugin from './link'
import makeMentionPlugin from './mention'
import makeNoteLinkPlugin from './NoteLinkInAppPlugin'

export default async ({
  iframelyApiKey,
  hasEditorNextFeatureFlag = false,
} = {}) => {
  const SliteEditorPlugins = hasEditorNextFeatureFlag
    ? (await import(/* webpackChunkName: "editor-next" */ './EditorNextPlugins'))
        .plugins
    : BaseEditorPlugins

  return Promise.all([
    SliteEditorPlugins.CrashPlugin(),
    SliteEditorPlugins.HistoryPlugin(),
    SliteEditorPlugins.CorePlugin(),
    SliteEditorPlugins.BlockquotePlugin(),
    SliteEditorPlugins.CodePlugin(),
    SliteEditorPlugins.ImagePlugin({ enableLightbox: false }),
    makeMentionPlugin({ MentionPlugin: SliteEditorPlugins.MentionPlugin })(),
    makeNoteLinkPlugin({ NoteLinkPlugin: SliteEditorPlugins.NoteLinkPlugin })(),
    SliteEditorPlugins.FilePlugin(),
    SliteEditorPlugins.TodoPlugin(),
    SliteEditorPlugins.LineBreakPlugin(),
    SliteEditorPlugins.TablePlugin(),
    makeLinkPlugin({ LinkPlugin: SliteEditorPlugins.LinkPlugin })({
      isEditable: false,
    }),
    SliteEditorPlugins.SeparatorPlugin(),
    SliteEditorPlugins.EmbedPlugin({ enableLightbox: false, iframelyApiKey }),
    SliteEditorPlugins.EmbedPlaceholderPlugin(),
    SliteEditorPlugins.RichTextPlugin(),
    SliteEditorPlugins.TypingPlugin(),
    SliteEditorPlugins.IntegrationTilePlugin(),
  ])
}
